jQuery(function($){
    function xml2json(xml) {
        try {
            var obj = {};
            if (xml.children.length > 0) {
                for (var i = 0; i < xml.children.length; i++) {
                    var item = xml.children.item(i);
                    var nodeName = item.nodeName;
      
                if (typeof (obj[nodeName]) == "undefined") {
                    obj[nodeName] = xml2json(item);
                } else {
                    if (typeof (obj[nodeName].push) == "undefined") {
                    var old = obj[nodeName];
      
                    obj[nodeName] = [];
                    obj[nodeName].push(old);
                    }
                    obj[nodeName].push(xml2json(item));
                }
            }
        } else {
            obj = xml.textContent;
        }
            return obj;
        } catch (e) {
            console.log(e.message);
        }
    }


    function RSSFeed(node, count) {
        this.container = node
        this.wrapper = this.container.querySelector('.home-news-list')
        this.link = 'https://app.meltwater.com/gyda/outputs/5e218810716ea2bca5c1da31/rendering?apiKey=572c75d47372e786ed2c1e7c&type=rss'
        this.count = count

        this.pasteItems = this.pasteItems.bind(this)

        this.Init()
    }


    RSSFeed.prototype.pasteItems = function() {
        var items = this.count ? this.items.slice(0, 5) : this.items,
            _this = this

        items.forEach(function(item) {
            var node = document.createElement('li')
            node.classList.add('home-news-item')
            // node.classList.add('title')

            var html = 
                '<p class="home-news-published">' + 
                    (item.source ? item.source : 'Lokale medier') + 
                    ' – <time>' +
                    new Date(item.pubDate).toISOString().split('T')[0].split('-').reverse().join('.') +
                '</time></p>' +
                '<a target="_blank" href="' + item.link + '" class="home-news-link">' + item.title + '</a>'

            node.innerHTML = html

            _this.wrapper.appendChild(node)
        })

    }


    RSSFeed.prototype.Init = function() {
        var _this = this

        $.get(this.link)
            .done(function(data) {
                _this.items = xml2json(data).rss.channel.item
                // console.log(_this.items)
                _this.pasteItems()
            })
            .fail(function(err) {
                console.log(err)
            })
    }


    var home_rss = document.querySelector('#home-rss'),
        full_rss = document.querySelector('#news-feed')


    if (home_rss) {
        new RSSFeed(home_rss, 5)

    } else if (full_rss) {
        new RSSFeed(full_rss)
    }
})